import { render } from "./AsyncButton.vue?vue&type=template&id=67c6ddbe&scoped=true&ts=true"
import script from "./AsyncButton.vue?vue&type=script&lang=ts"
export * from "./AsyncButton.vue?vue&type=script&lang=ts"

import "./AsyncButton.vue?vue&type=style&index=0&id=67c6ddbe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c6ddbe"]])

export default __exports__